/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {UpdateUserGroup} from '../models/UpdateUserGroup';
import type {UserGroupUpdateResult} from '../models/UserGroupUpdateResult';

export interface AssignGroupMemberBulk$Request {
    updateUserGroup: Array<UpdateUserGroup>;
    reason?: string;
}

export interface AssignGroupMemberBulk$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const assignGroupMemberBulkRequest = createAction<PayloadData<void, AssignGroupMemberBulk$Request>>('BULK_GROUP_ASSIGN__ASSIGN_GROUP_MEMBER_BULK__REQUEST');
export const assignGroupMemberBulkSuccess = createAction<PayloadData<string, AssignGroupMemberBulk$Request>>('BULK_GROUP_ASSIGN__ASSIGN_GROUP_MEMBER_BULK__SUCCESS');
export const assignGroupMemberBulkFailure = createAction<PayloadData<Error, AssignGroupMemberBulk$Request, true>>('BULK_GROUP_ASSIGN__ASSIGN_GROUP_MEMBER_BULK__FAILURE');

export const assignGroupMemberBulkActions = [
    assignGroupMemberBulkRequest,
    assignGroupMemberBulkSuccess,
    assignGroupMemberBulkFailure
] as const;

/**
 * @param {Array<UpdateUserGroup>} meta.updateUserGroup
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const assignGroupMemberBulk = (meta: AssignGroupMemberBulk$Request, config?: AssignGroupMemberBulk$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: assignGroupMemberBulkActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/bulk-actions/users/groups`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.updateUserGroup,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetGroupMemberBulkResult$Request {
    id: string;
}

export interface GetGroupMemberBulkResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getGroupMemberBulkResultRequest = createAction<PayloadData<void, GetGroupMemberBulkResult$Request>>('BULK_GROUP_ASSIGN__GET_GROUP_MEMBER_BULK_RESULT__REQUEST');
export const getGroupMemberBulkResultSuccess = createAction<PayloadData<UserGroupUpdateResult, GetGroupMemberBulkResult$Request>>('BULK_GROUP_ASSIGN__GET_GROUP_MEMBER_BULK_RESULT__SUCCESS');
export const getGroupMemberBulkResultFailure = createAction<PayloadData<Error, GetGroupMemberBulkResult$Request, true>>('BULK_GROUP_ASSIGN__GET_GROUP_MEMBER_BULK_RESULT__FAILURE');

export const getGroupMemberBulkResultActions = [
    getGroupMemberBulkResultRequest,
    getGroupMemberBulkResultSuccess,
    getGroupMemberBulkResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getGroupMemberBulkResult = (meta: GetGroupMemberBulkResult$Request, config?: GetGroupMemberBulkResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getGroupMemberBulkResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/groups`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetUserGroupUpdateProgress$Request {
    id: string;
}

export interface GetUserGroupUpdateProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserGroupUpdateProgressRequest = createAction<PayloadData<void, GetUserGroupUpdateProgress$Request>>('BULK_GROUP_ASSIGN__GET_USER_GROUP_UPDATE_PROGRESS__REQUEST');
export const getUserGroupUpdateProgressSuccess = createAction<PayloadData<BulkProgress, GetUserGroupUpdateProgress$Request>>('BULK_GROUP_ASSIGN__GET_USER_GROUP_UPDATE_PROGRESS__SUCCESS');
export const getUserGroupUpdateProgressFailure = createAction<PayloadData<Error, GetUserGroupUpdateProgress$Request, true>>('BULK_GROUP_ASSIGN__GET_USER_GROUP_UPDATE_PROGRESS__FAILURE');

export const getUserGroupUpdateProgressActions = [
    getUserGroupUpdateProgressRequest,
    getUserGroupUpdateProgressSuccess,
    getUserGroupUpdateProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserGroupUpdateProgress = (meta: GetUserGroupUpdateProgress$Request, config?: GetUserGroupUpdateProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getUserGroupUpdateProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/groups/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface StopUserGroupBulkUpdate$Request {
    id: string;
}

export interface StopUserGroupBulkUpdate$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const stopUserGroupBulkUpdateRequest = createAction<PayloadData<void, StopUserGroupBulkUpdate$Request>>('BULK_GROUP_ASSIGN__STOP_USER_GROUP_BULK_UPDATE__REQUEST');
export const stopUserGroupBulkUpdateSuccess = createAction<PayloadData<void, StopUserGroupBulkUpdate$Request>>('BULK_GROUP_ASSIGN__STOP_USER_GROUP_BULK_UPDATE__SUCCESS');
export const stopUserGroupBulkUpdateFailure = createAction<PayloadData<Error, StopUserGroupBulkUpdate$Request, true>>('BULK_GROUP_ASSIGN__STOP_USER_GROUP_BULK_UPDATE__FAILURE');

export const stopUserGroupBulkUpdateActions = [
    stopUserGroupBulkUpdateRequest,
    stopUserGroupBulkUpdateSuccess,
    stopUserGroupBulkUpdateFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const stopUserGroupBulkUpdate = (meta: StopUserGroupBulkUpdate$Request, config?: StopUserGroupBulkUpdate$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: stopUserGroupBulkUpdateActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/bulk-actions/users/groups`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

